import { createReducer } from 'reduxsauce'
import Types from './actionTypes'
 
export const INITIAL_STATE = { lineId: null, errors: null, geoJsonData: null, isloading: false }

export const saveLineId = (state = INITIAL_STATE, action) => {
  return { ...state, lineId: action.lineId };
}

export const fetchGeojsonData = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, errors: null };
}

export const fetchGeojsonDataSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, geoJsonData: action.responseData };
}

export const fetchGeojsonDataFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, errors: action.error };
}

export const HANDLERS = {
  [Types.SAVE_LINE_ID]: saveLineId,
  [Types.FETCH_GEOJSON_DATA]: fetchGeojsonData,
  [Types.FETCH_GEOJSON_DATA_SUCCESS]: fetchGeojsonDataSuccess,
  [Types.FETCH_GEOJSON_DATA_FAILURE]: fetchGeojsonDataFailure
}
 
export default createReducer(INITIAL_STATE, HANDLERS);
